const {
  REACT_APP_SPARC_BASE: SPARC_BASE,
  REACT_APP_USER_VERIFY_BASE: USER_VERIFY_BASE,
  REACT_APP_SPARC_BASE_SANDBOX: SPARC_BASE_SANDBOX,
  REACT_APP_MSO_GATEWAY_BASE_URL: MSO_GATEWAY_BASE_URL,
  REACT_APP_MSO_BASE_URL: MSO_BASE_URL,
  REACT_APP_ENV,
  REACT_APP_USER_POOL_ID: USER_POOL_ID,
  REACT_APP_CLIENT_ID: CLIENT_ID,
  REACT_APP_SENTRY_DSN: SENTRY_DSN,
  REACT_APP_SENTRY_ENV: SENTRY_ENV,
  REACT_APP_PENDO_KEY: PENDO_KEY,
  REACT_APP_CHECKOUT_HOST: CHECKOUT_HOST,
  REACT_APP_INTERCOM_KEY: INTERCOM_KEY,
  REACT_APP_PAYMENT_SDK_URL: PAYMENT_SDK_URL,
  REACT_APP_SHELL_ORIGIN: SHELL_ORIGIN,
} = process.env;

// Export ENV with production as default fallback
export const ENV = REACT_APP_ENV || 'production';

export {
  SPARC_BASE,
  USER_VERIFY_BASE,
  SPARC_BASE_SANDBOX,
  MSO_GATEWAY_BASE_URL,
  MSO_BASE_URL,
  USER_POOL_ID,
  CLIENT_ID,
  SENTRY_DSN,
  SENTRY_ENV,
  PENDO_KEY,
  CHECKOUT_HOST,
  INTERCOM_KEY,
  PAYMENT_SDK_URL,
  SHELL_ORIGIN,
};
